'use client'
import Image from 'next/image'

interface IProps {
  imageCaption?: string
  showCaptions: boolean
  hideCaptions: () => void
}

export const GalleryCaption = ({ imageCaption, showCaptions, hideCaptions }: IProps) => {
  return (
    <>
      <figcaption
        className={`absolute z-[100] flex justify-between rounded-b-lg bottom-[0.01px] left-0 w-full italic bg-black bg-opacity-45 text-gray-200 text-sm py-2 px-2 sm:py-4 sm:px-4 transition-all duration-500 ease-out ${
          showCaptions ? '' : 'opacity-0 invisible'
        }`}
      >
        <div>{imageCaption}</div>
        <button className="ml-2" onClick={hideCaptions}>
          <Image
            src="/images/favicons/close-flowbite.svg"
            alt="close caption"
            width={24}
            height={24}
          />
        </button>
      </figcaption>
    </>
  )
}

export default GalleryCaption
